import { render, staticRenderFns } from "./IconChartBarSolid.vue?vue&type=template&id=073bd96a"
import script from "./IconChartBarSolid.vue?vue&type=script&lang=js"
export * from "./IconChartBarSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports